export const CATEGORICAL_SECTION_TEST_ID = "categorical-section";
